import { gql } from '@apollo/client';

export default gql`
  mutation ResetMFA($input: ResetMfaInput!) {
    resetMFA(input: $input)
  }
`;
